let TableId: string;
let UrlBody: string;
declare let XLSX: any;
declare let List: any;

namespace Controlli {
    export namespace UtilityTabella {
        export function InitTable(options: TableInitOptions) {
            TableId = options.TableId;
            if (options.EnableListJs) {
                InitListJs(options.DivTableId, options.ListJsEnablePagination, options.ListJsRowPerPage, options.ListJsEntries);
            }
            if (options.EnableExportTable) {
                SetupExportTable(`#${options.ExportBtnId}`, options.ExportFilename, options.ExportSheetname);
            }
            if (options.EnableToggleCols) {
                ShowHideCols(`.${options.ToggleElementClass}`, options.ToggleDataAttrColIndex, options.ToggleLocalStorageCols)
            }
        }

        export function InitListJs(divContainer: string, enablePagination: boolean, rowPerPage: number, option: any) {
            let optionsListJs = null;

            if (enablePagination) {
                optionsListJs = {
                    valueNames: option,
                    page: rowPerPage,
                    pagination: enablePagination
                };
            } else {
                optionsListJs = {
                    valueNames: option,
                };
            }

            const listContainer = document.getElementById(divContainer) ?? document.querySelector(divContainer);
            if (!listContainer || !listContainer.querySelector('.list')) {
                return;
            }

            _listContenuti = new List(listContainer, optionsListJs);

            _listContenuti.on('updated', function (list) {
                if (list.matchingItems.length > 0) {
                    $('.noresult').hide()
                } else {
                    $('.noresult').show()
                }
            });
        }

        //Inizializzazione tabella semplice
        export function InitTabellaSemplice(baseUrlFiltro: string, bodyTabella: string) {
            $(bodyTabella).fadeOut(200, "swing", function () {
                $(bodyTabella).html(Controlli.Ajax.AjaxGetHTML(baseUrlFiltro));

                Controlli.Utility.DestroyControl(bodyTabella)
                Controlli.Utility.RefreshControl(bodyTabella)
            });
            $(bodyTabella).fadeIn(200);
        }

        function SetupExportTable(exportBtnId: string, filename: string, sheetName: string) {
            $(exportBtnId).on("click", function () {
                let table = document.getElementById(TableId);
                let option = {
                    headers: true,              // (Boolean), display table headers (th or td elements) in the <thead>, (default: true)
                    footers: false,             // (Boolean), display table footers (th or td elements) in the <tfoot>, (default: false)
                    formats: ["xlsx"],          // (String[]), filetype(s) for the export, (default: ['xlsx', 'csv', 'txt'])
                    filename: filename,         // (id, String), filename for the downloaded file, (default: 'id')
                    bootstrap: true,            // (Boolean), style buttons using bootstrap, (default: true)
                    position: "bottom",         // (top, bottom), position of the caption element relative to table, (default: 'bottom')
                    ignoreRows: null,           // (Number, Number[]), row indices to exclude from the exported file(s) (default: null)
                    ignoreCols: null,           // (Number, Number[]), column indices to exclude from the exported file(s) (default: null)
                    trimWhitespace: true,       // (Boolean), remove all leading/trailing newlines, spaces, and tabs from cell text in the exported file(s) (default: false)
                    RTL: false,                 // (Boolean), set direction of the worksheet to right-to-left (default: false)
                    sheetname: sheetName,       // (id, String), sheet name for the exported spreadsheet, (default: 'id')
                };
                let wb = XLSX.utils.table_to_book(table, option);
                XLSX.writeFile(wb, `${filename}.xlsx`);
            });
        }
        function ShowHideCols(toggleElementClass: string, dataAttrColIndex: string, itemNameToggle: string) {

            const checkboxes = document.querySelectorAll(toggleElementClass) as NodeListOf<HTMLInputElement>;

            checkboxes.forEach(checkbox => {
                const columnIndex = parseInt(checkbox.getAttribute(dataAttrColIndex) || "0", 10);

                checkbox.addEventListener("change", function () {
                    ToggleColumn(columnIndex, this.checked, itemNameToggle);
                });
            });
        }
        function ToggleColumn(columnIndex: number, isVisible: boolean, itemNameToggle: string) {
            const table = document.getElementById(TableId) as HTMLTableElement;

            // Gestisci le celle dell'header (thead)
            const headerCells = table.querySelectorAll('thead th');
            if (headerCells[columnIndex]) {
                (headerCells[columnIndex] as HTMLElement).style.display = isVisible ? "" : "none";
            }

            // Gestisci le celle del body (tbody)
            const bodyRows = table.querySelectorAll('tbody tr');
            bodyRows.forEach(row => {
                const cells = row.querySelectorAll('td');
                if (cells[columnIndex]) {
                    (cells[columnIndex] as HTMLElement).style.display = isVisible ? "" : "none";
                }
            });

            // Salva la scelta nel localStorage
            localStorage.setItem(`${itemNameToggle}-${columnIndex}`, isVisible ? "show" : "hide");
        }

        export class BaseFiltriListaDto {
            constructor(righePerPagina: number|null = 25) {
                const annoAttuale = new Date().getFullYear();
                const dataIniziale = new Date(annoAttuale - 1, 0);
                const dataFinale = new Date();

                this.PaginaAttuale = 1;
                this.PagineTotali = 2;
                this.GenericId = 0;
                this.RicercaTestuale = '';
                this.RighePerPagina = righePerPagina ?? 25;
                this.DataFine = dataFinale.toDateString();
                this.DataInizio = dataIniziale.toDateString();
            }
            RighePerPagina: number;
            PaginaAttuale: number;
            PagineTotali: number;
            GenericId: number;
            DataInizio: string;
            DataFine: string;
            RicercaTestuale: string;
        }

        class TableInitOptions {
            TableId: string;
            DivTableId: string;
            //List.js
            EnableListJs: boolean;
            ListJsEntries: any;
            ListJsEnablePagination: boolean;
            ListJsRowPerPage: number;
            //TableExports.js
            EnableExportTable: boolean;
            ExportBtnId: string;
            ExportFilename: string;
            ExportSheetname: string;
            //Toggle Cols
            EnableToggleCols: boolean;
            ToggleElementClass: string;
            ToggleDataAttrColIndex: string;
            ToggleLocalStorageCols: string;
        }

        // ============================================================================
        // GESTIONE INFINITE SCROLL
        // ============================================================================
        const KeyupRegex = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
        const KeySpecials = ["Enter", "Backspace", "Control", "Delete"];
        const operationSecondTimeoutMs = 1000; // 1 second
        let KeyupTimer: string | number | NodeJS.Timeout;

        export interface BaseInfiniteScrollOptions {
            divTabella: string;
            bodyTabella: string;
            baseUrlFiltro: string;
            rigaTabella: string;
            loadStatusClass: string;
        }
        export function InitOptionsInfiniteScroll(contestoSorgente: string): BaseInfiniteScrollOptions {
            let opzioni = {} as BaseInfiniteScrollOptions;

            //Inizializzazione opzioni infinite scroll
            let dataAttr = Controlli.Utility.BuildDataAttr(contestoSorgente, "infscroll-url", false);
            opzioni.baseUrlFiltro = $(`[data-${dataAttr}]`).data(dataAttr);
            dataAttr = Controlli.Utility.BuildDataAttr(contestoSorgente, "infscroll-bodytab", false);
            opzioni.bodyTabella = $(`[data-${dataAttr}]`).data(dataAttr);
            dataAttr = Controlli.Utility.BuildDataAttr(contestoSorgente, "infscroll-divtab", false);
            opzioni.divTabella = $(`[data-${dataAttr}]`).data(dataAttr);
            dataAttr = Controlli.Utility.BuildDataAttr(contestoSorgente, "infscroll-rigatab", false);
            opzioni.rigaTabella = $(`[data-${dataAttr}]`).data(dataAttr);
            dataAttr = Controlli.Utility.BuildDataAttr(contestoSorgente, "infscroll-loadclass", false);
            opzioni.loadStatusClass = $(`[data-${dataAttr}]`).data(dataAttr);

            return opzioni;
        }

        export function InitInfiniteScroll(options: BaseInfiniteScrollOptions, methodType: Utility.HttpMethod, dataFilter?: BaseFiltriListaDto, appendOprations?: (items: any) => void) {
            let infiniteScroll: any;

            switch (methodType) {
                case Utility.HttpMethod.POST:
                    infiniteScroll = InitInfiniteScrollPost(options.bodyTabella, options.baseUrlFiltro, options.rigaTabella, options.divTabella, options.loadStatusClass, dataFilter)
                    break;
                case Utility.HttpMethod.GET:
                    infiniteScroll = InitInfiniteScrollGet(options.bodyTabella, options.baseUrlFiltro, options.rigaTabella, options.divTabella, options.loadStatusClass)
                    break;
                case Utility.HttpMethod.PUT:
                case Utility.HttpMethod.DELETE:
                default:
            }

            const infScroll = infiniteScroll.data('infiniteScroll');

            infiniteScroll.on('load.infiniteScroll', () => {
                dataFilter.PaginaAttuale = infScroll.pageIndex;
            });

            infiniteScroll.on('append.infiniteScroll', (event, body, path, items: NodeList) => {
                if (items.length > 0) {
                    Controlli.Utility.DestroyControl(options.bodyTabella);
                    Controlli.Utility.RefreshControl(options.bodyTabella);
                    if (appendOprations) {
                        appendOprations(items)
                    }
                }
            });

            return infiniteScroll;
        }
        export function InitInfiniteScrollPost(bodyTabella: string, baseUrlFiltro: string, rigaTabella: string, divTabella: string, classStatus: string, filtro: any, prefill: boolean = true) {
            let infiniteScrollTable = ($(bodyTabella) as any).infiniteScroll({
                path: () => { return location.origin + baseUrlFiltro; },
                append: rigaTabella,
                status: classStatus,
                elementScroll: divTabella,
                history: false,
                debug: false,
                prefill: prefill,
                scrollThreshold: 500,
                responseBody: 'text',
                fetchOptions: function () {
                    return {
                        method: "POST",
                        body: JSON.stringify({ filtro: filtro }),
                        headers: {
                            "Content-Type": "application/json charset=utf-8",
                        },
                        cache: 'no-store'
                    };
                },
            });
            return infiniteScrollTable;
        }
        export function InitInfiniteScrollGet(bodyTabella: string, baseUrlFiltro: string, rigaTabella: string, divTabella: string, classStatus: string, prefill: boolean = true) {
            let infiniteScrollTable = ($(bodyTabella) as any).infiniteScroll({
                path: () => { return location.origin + baseUrlFiltro; },
                append: rigaTabella,
                status: classStatus,
                elementScroll: divTabella,
                history: false,
                debug: false,
                prefill: prefill,
                scrollThreshold: 500,
                responseBody: 'text',
            });
            return infiniteScrollTable;
        }
        export function SetupInfiniteScrollAndSearch(opzioni: BaseInfiniteScrollOptions, filtro: BaseFiltriListaDto, contestoDataAttr: string): any {
            let tabella = InitInfiniteScroll(opzioni, Controlli.Utility.HttpMethod.POST, filtro, null);
            let dataAttr = Controlli.Utility.BuildDataAttr(contestoDataAttr, "ricerca-tab");

            $(`[${dataAttr}]`).on("keyup", function (e) {
                const searchTerm = $(this).val() as string;

                if (searchTerm !== filtro.RicercaTestuale && (searchTerm === "" || KeyupRegex.test(searchTerm) || KeySpecials.includes(e.key))) {
                    filtro.RicercaTestuale = searchTerm;
                    clearTimeout(KeyupTimer);
                    KeyupTimer = setTimeout(() => ResetInfiniteScroll(
                        opzioni,
                        tabella,
                        Controlli.Utility.HttpMethod.POST,
                        filtro,
                        null
                    ), operationSecondTimeoutMs);
                }
            });

            return tabella;
        }

        export function ResetInfiniteScroll(opzioni: BaseInfiniteScrollOptions, infiniteScrollObj: any, methodType: Utility.HttpMethod, filtroData?: BaseFiltriListaDto, appendOprations?: (items: any) => void): any {
            $(opzioni.divTabella).scrollTop(0);

            $(opzioni.bodyTabella).fadeOut(200, "swing", function () {
                let infScroll = infiniteScrollObj.data('infiniteScroll');
                if (infScroll) {
                    infiniteScrollObj.infiniteScroll('destroy');
                    infiniteScrollObj.removeData('infiniteScroll');
                    infiniteScrollObj.off('.infiniteScroll');
                    infiniteScrollObj.empty();
                }

                filtroData.PaginaAttuale = 1;
                filtroData.PagineTotali = 2;

                InitInfiniteScroll(opzioni, methodType, filtroData, appendOprations);

                if (appendOprations) {
                    appendOprations($(opzioni.bodyTabella));
                }

                $(opzioni.bodyTabella).fadeIn(200);
            });
        }
    }
}